import { renderBuildFieldErrorHelperSegmentTemplate } from '@next-adapter/templates/renderers/generators/form-pipeline/form-component-shared/build-field-error-helper.js'
export function buildFieldErrorHelper(): string {
  return renderBuildFieldErrorHelperSegmentTemplate()
}
